// Cursor.jsx
import React, { useEffect, useState } from "react";
import "../cursor.css";

const Cursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [color, setColor] = useState("rgba(255,0,0,0.5)");

  useEffect(() => {
    const handleMouseMove = (e) => {
      // Use clientX/clientY for fixed positioning
      setPosition({ x: e.clientX, y: e.clientY });

      // Dynamic color based on mouse position
      const red = Math.round((e.clientX / window.innerWidth) * 255);
      const green = Math.round((e.clientY / window.innerHeight) * 255);
      const blue = 150;
      setColor(`rgba(${red},${green},${blue},0.6)`);
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      className="custom-cursor"
      style={{
        left: position.x,
        top: position.y,
        backgroundColor: color,
      }}
    ></div>
  );
};

export default Cursor;
